import React from 'react';
import Image from 'next/image';

import classes from '../../index.module.css';
import { PhoneMockupProps } from './models';

const PhoneMockup = ({ src, alt, priority = false, glow = false, className = '', children }: PhoneMockupProps) => {
    return (
        <div className={`relative ${className}`}>
            {glow && <span className={classes.phoneGlow} aria-hidden />}
            <div className={classes.phoneFrame}>
                <span className={classes.phoneNotch} aria-hidden />
                <div className={classes.phoneScreen}>
                    {children ?? (
                        <Image
                            src={src}
                            alt={alt}
                            fill
                            priority={priority}
                            sizes='(max-width: 768px) 240px, 300px'
                            className='object-cover object-top'
                        />
                    )}
                    <span className={classes.phoneGlare} aria-hidden />
                </div>
            </div>
        </div>
    );
};

export default PhoneMockup;
